function JobDescription({ html }) {
  return (
    <div
      className="
        prose max-w-none mt-6

        /* Headings created via <strong> */
        prose-strong:block
        prose-strong:text-xl
        prose-strong:font-semibold
        prose-strong:text-[#1F2937]
        prose-strong:mt-8
        prose-strong:mb-3

        /* Paragraph text */
        prose-p:text-[#5F6870]
        prose-p:text-lg
        prose-p:leading-relaxed
        prose-p:mt-2
      

        /* Ordered list */
        prose-ol:mt-4
        prose-ol:ml-5
        prose-ol:list-decimal

        /* List items */
        prose-li:mt-4
        prose-li:text-[#4B5563]

        /* List item titles */
        prose-li > p:first-child strong:text-[#475569]
        prose-li > p:first-child strong:font-semibold
      "
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default JobDescription;
